// src/Components/Avatar.js
import React, { useState } from "react";

const Avatar = ({ name = "User", src, size = 30, className = "" }) => {
  const [imgError, setImgError] = useState(false);

  const fallbackUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=800080&color=fff&size=${size * 2}`;

  return (
    <img
      src={!imgError && src ? src : fallbackUrl}
      alt={name}
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        objectFit: "cover",
        ...(!className && {
          border: "1px solid #ccc",
        }),
      }}
      onError={() => setImgError(true)}
    />
  );
};

export default Avatar;
